export default "__VITE_ASSET__1e7ebef1__"